import React from 'react';
import {
  BankOutlined,
  DollarOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { Typography } from 'antd';
import { Job } from '../../job/models/job.model';

interface JobDetailsPanelProps {
  job: Job;
  salaryRange: string;
}

const JobDetailsPanel: React.FC<JobDetailsPanelProps> = ({
  job,
  salaryRange,
}) => {
  const location = job.location?.replace(/-/g, ' ') || 'Not specified';
  const client = job.client?.name || 'Not specified';

  return (
    <section className="job-details" aria-labelledby="job-details-heading">
      <header className="job-details__header">
        <Typography.Title
          id="job-details-heading"
          level={3}
          className="!mb-1 !text-lg"
        >
          Job details
        </Typography.Title>
        <Typography.Paragraph type="secondary" className="!mb-0 text-sm">
          Role information and responsibilities for this application.
        </Typography.Paragraph>
      </header>

      <div className="job-details__summary">
        <div className="job-details__role-icon" aria-hidden>
          <FileTextOutlined />
        </div>
        <div className="job-details__role">
          <Typography.Title level={4} className="!mb-2 !mt-0 !text-base">
            {job.name || 'Untitled position'}
          </Typography.Title>
          <div className="job-details__metadata">
            <span>
              <BankOutlined aria-hidden />
              {client}
            </span>
            <span>
              <EnvironmentOutlined aria-hidden />
              {location}
            </span>
          </div>
        </div>
        <div className="job-details__salary">
          <span>
            <DollarOutlined aria-hidden />
            Salary range
          </span>
          <strong>{salaryRange}</strong>
        </div>
      </div>

      <section
        className="job-details__description"
        aria-labelledby="job-description-heading"
      >
        <div className="job-details__description-heading">
          <span className="job-details__description-icon" aria-hidden>
            <FileTextOutlined />
          </span>
          <div>
            <Typography.Title
              id="job-description-heading"
              level={4}
              className="!mb-1 !text-base"
            >
              About the role
            </Typography.Title>
            <Typography.Text type="secondary" className="text-xs">
              Responsibilities, expectations, and required experience
            </Typography.Text>
          </div>
        </div>

        {job.description ? (
          <div
            className="job-description-html"
            dangerouslySetInnerHTML={{ __html: job.description }}
          />
        ) : (
          <div className="job-details__empty">
            <FileTextOutlined aria-hidden />
            <div>
              <strong>No job description available</strong>
              <p>The role details have not been added yet.</p>
            </div>
          </div>
        )}
      </section>
    </section>
  );
};

export default JobDetailsPanel;
